<template>
  <div class="cell-options-data-dialog">
    <el-collapse v-model="activeNames">
      <el-collapse-item
        @mousedown.native="collapseMouseDown($event, '1')"
        title="数据绑定"
        name="1"
        class="mapping_container"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1')">
          <div
            v-for="(item, index) in getAllElements"
            :key="index"
            :class="item.filedMapping.flag && item.filedMapping.value ? 'mapping_content checked' : 'mapping_content'"
            @mouseenter="highlightedBaseComponent(item)"
            @mouseleave="cancelHighlightedBaseComponent(item)"
          >
            <div class="verticallyBetweenCenter">
              <div class="content-title">
                {{ getValueByTypeHandle(item.innerElement) }}
              </div>
              <div
                class="verticallyCenter"
                v-if="
                  !item.filedMapping.isDate &&
                  item.filedMapping.flag &&
                  (item.innerElement == 'cxText' || item.innerElement == 'cxButton')
                "
              >
                <el-checkbox v-model="item.isHyperlink" @change="changeItemOptions($event, item, 'isHyperlink')"
                  >超链接</el-checkbox
                >
                <el-tooltip
                  popper-class="maxWidth160"
                  placement="top"
                  :open-delay="1000"
                  content="勾选后，会出现链接地址配置项，可关联数据源链接字段"
                  ><i class="tips-btn icon-portal-info2"></i
                ></el-tooltip>
              </div>
            </div>
            <div class="select_content mt8">
              <el-select
                style="width: 100%"
                v-model="item.filedMapping.value"
                @change="
                  changeFiledMappingHandle(
                    $event,
                    {
                      elementInDataGridId: item.elementInDataGridId,
                      flag: 'value'
                    },
                    true
                  )
                "
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="(item1, index1) in filedMappingList"
                  :key="index + '_' + index1"
                  :label="item1.label"
                  :value="item1.value"
                >
                  <span style="font-size: 13px">{{ item1.label }}</span>
                </el-option>
              </el-select>
            </div>
            <div
              class="verticallyCenter mapping_date_content mt8"
              v-if="item.filedMapping.flag && !item.filedMapping.isDate && item.innerElement === 'cxText'"
            >
              <label class="date-label">显示为:</label>
              <el-dropdown trigger="click" @command="onChangeMappingType($event, item)">
                <span class="el-dropdown-link">
                  {{ fieldMappingDataType(item.filedMapping) }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu
                  slot="dropdown"
                  :class="request_prefix === 'bigScreen' ? 'bigScreen custom-dropdown' : 'custom-dropdown'"
                >
                  <el-dropdown-item v-for="item1 in dataTypeList" :key="item1.value" :command="item1.value">
                    <div :class="item.filedMapping.dataType === item1.value ? 'dropdown-item active' : 'dropdown-item'">
                      {{ item1.label }}
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div
              class="verticallyCenter mapping_date_content mt8"
              v-if="item.filedMapping.flag && item.filedMapping.isDate"
            >
              <label class="date-label">显示为:</label>
              <el-dropdown trigger="click" @command="onChangeMappingDateStyle($event, item)">
                <span class="el-dropdown-link">
                  {{ fieldMappingDateStyle(item.filedMapping) }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu
                  slot="dropdown"
                  :class="request_prefix === 'bigScreen' ? 'bigScreen custom-dropdown' : 'custom-dropdown'"
                >
                  <div class="dropdown-title-show">
                    <cx-check-box :value.sync="item.filedMapping.dateTitle" @change="onChangeMappingDateTitle"
                      >显示字段名</cx-check-box
                    >
                  </div>
                  <el-dropdown-item v-for="item1 in dateOptions" :key="item1.value" :command="item1.value">
                    <div
                      :class="item.filedMapping.dateStyle === item1.value ? 'dropdown-item active' : 'dropdown-item'"
                    >
                      {{ item1.label }}
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div v-if="item.innerElement == 'cxVideo' || item.innerElement == 'cxAudio'" class="vedio-style mt8">
              <el-checkbox
                v-model="item.videoObjectId"
                @change="changeItemOptions($event, item, 'videoObjectId')"
              ></el-checkbox
              ><label>支持云盘</label>
            </div>
            <div class="select_content mt8" v-if="item.isHyperlink">
              <el-select
                v-if="item.filedMapping.flag"
                v-model="item.filedMapping.linkUrl"
                @change="
                  changeFiledMappingHandle(
                    $event,
                    {
                      elementInDataGridId: item.elementInDataGridId,
                      flag: 'linkUrl'
                    },
                    true
                  )
                "
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="(item1, index1) in filedMappingList"
                  :key="index + '_' + index1"
                  :label="item1.label"
                  :value="item1.value"
                >
                  <span style="font-size: 13px">{{ item1.label }}</span>
                </el-option>
              </el-select>
            </div>
            <div class="verticallyCenter mt4" v-if="item.isHyperlink">
              <el-checkbox v-model="item.openBlankPage" @change="changeItemOptions($event, item, 'openBlankPage')"
                >新页面打开</el-checkbox
              >
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '2')" title="链接跳转" name="2">
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')">
          <div class="setting-item">请选择点击区域</div>
          <div class="setting-item syncCol_content">
            <el-checkbox
              v-model="getAllElementsIsCheckedAll"
              :indeterminate="allElementsIsCheckedAll"
              class="ml8"
              @change="checkAllElementsHandle"
            ></el-checkbox
            ><label>全部</label>
            <li
              v-for="(item, index) in getAllElements"
              class="col_li"
              :key="index"
              @mouseenter="highlightedBaseComponent(item)"
              @mouseleave="cancelHighlightedBaseComponent(item)"
            >
              <el-checkbox
                v-model="item.filedMapping.checked"
                @change="
                  changeFiledMappingHandle($event, { elementInDataGridId: item.elementInDataGridId, flag: 'checked' })
                "
              ></el-checkbox>
              <span>{{ getValueByTypeHandle(item.innerElement) }}</span>
            </li>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        <span
          >开启后，在数据源请求时，会在"searchKeys"中的"sw"中返回子页面参数；如果使用了“requestUrl”，会在请求中增加子页面参数</span
        >
      </p>
      <div class="box">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAttrById, getValueByType } from "utils"
export default {
  components: {},
  props: {
    options: { type: Object }
  },
  data() {
    return {
      activeNames: [],
      collapseActiveNames: [],
      completeData: [],
      filedMappingList: [], // 用来做映射的字段集合
      allElementsIsCheckedAll: false,
      getAllElementsIsCheckedAll: false, //是否全选所有元素
      detailPageElementIndexList: [], //当前col中可以跳转链接的组件
      dateOptions: [
        {
          value: "7",
          label: "年-月-日 时:分:秒"
        },
        {
          value: "10",
          label: "年-月-日 时:分"
        },
        {
          value: "1",
          label: "年-月-日"
        },
        {
          value: "2",
          label: "年-月"
        },
        {
          value: "3",
          label: "月-日"
        },
        {
          value: "8",
          label: "时:分"
        },
        {
          value: "4",
          label: "年"
        },
        {
          value: "5",
          label: "月"
        },
        {
          value: "6",
          label: "日"
        },
        {
          value: "9",
          label: "文本格式"
        }
      ],
      explainDialog: false,
      explainImgSrc: require("../../../assets/images/tipsVideoImg/params-tips.png"),
      dataTypeList: [
        {
          label: "字段名称+字段内容",
          value: "dataKey"
        },
        {
          label: "字段内容",
          value: "dataValue"
        },
        {
          label: "字段名称",
          value: "dataName"
        }
      ]
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    getAllElements() {
      let checkedLength = 0
      const elementOptions = this.options.elementOptions
      for (let i = 0; i < elementOptions.length; i++) {
        const newVal = this.checkAndSetPrimaryVal(elementOptions[i], "filedMapping", "filedMapping", {
          value: null,
          label: null,
          flag: false,
          checked: false,
          isDate: false,
          dateStyle: "1",
          dataType: "dataValue"
        })
        if (newVal) {
          // 以前未设置的 加个默认值
          if (!newVal.dataType) {
            newVal.dataType = "dataValue"
          }
          const param = {
            ...this.ids,
            cellId: "root",
            elementInDataGridId: elementOptions[i].elementInDataGridId,
            option_val: newVal,
            option_name: "filedMapping"
          }
          this.$store.dispatch(this.request_prefix + "/changeDataGridOptions", param)
        }
        if (elementOptions[i].filedMapping?.checked) checkedLength++
      }
      this.getAllElementsIsCheckedAll = checkedLength === elementOptions.length
      this.allElementsIsCheckedAll = checkedLength > 0 && checkedLength < elementOptions.length
      return elementOptions
    },
    pageType() {
      return this.$store.state[this.request_prefix].type
    }
  },
  methods: {
    // 过滤详情页的参数
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    getValueByTypeHandle(type) {
      return getValueByType(type)
    },
    fieldMappingDataType(filedMapping) {
      const item = this.dataTypeList.find(data => data.value === filedMapping.dataType)
      return item.label || ""
    },
    fieldMappingDateStyle(filedMapping) {
      const item = this.dateOptions.find(data => data.value === filedMapping.dateStyle)
      return item.label || ""
    },
    onChangeMappingType(value, options) {
      this.changeFiledMappingHandle(
        value,
        {
          elementInDataGridId: options.elementInDataGridId,
          flag: "dataType"
        },
        true
      )
    },
    onChangeMappingDateStyle(value, options) {
      options.filedMapping.dateStyle = value
      this.startDraw()
    },
    onChangeMappingDateTitle() {
      this.startDraw()
    },
    getBaseModuleDataLoop() {
      const completeData = JSON.parse(window.localStorage.getItem("completeData"))[0]
      this.filedMappingList = []
      if (completeData) {
        // 组装字段映射的数据结构
        Object.keys(completeData).forEach((key, index) => {
          if (key !== "url" && key !== "publicId" && key !== "id" && key !== "pageType" && key !== "viewNum") {
            const temp = {
              value: key,
              label: completeData[key]?.key
            }
            this.filedMappingList.push(temp)
          }
          if (key === "viewNum") {
            const temp = {
              value: key,
              label: "浏览量"
            }
            this.filedMappingList.push(temp)
          }
        })
      }
      this.completeData = completeData
    },
    // 改变filedMapping的值
    changeFiledMappingHandle(data, params, isGetData) {
      let currentFiledMapping = JSON.parse(
        JSON.stringify(
          this.$getOptions({
            ...this.ids,
            elementInDataGridId: params.elementInDataGridId
          }).filedMapping
        )
      )
      if (params.flag === "checked") {
        currentFiledMapping.checked = data
        this.changeLinksHandle(data, params.elementInDataGridId)
      } else if (params.flag === "dataType") {
        currentFiledMapping[params.flag] = data
      } else if (params.flag === "linkUrl") {
        currentFiledMapping.linkUrl = data
      } else if (params.flag === "value") {
        currentFiledMapping.value = data
        if(data) {
          currentFiledMapping.flag = true
        }
        // 判断当前选中字段类型，如果是日期字段，则需要显示日期格式设置项
        const tempComplete = this.completeData
        tempComplete && Object.keys(tempComplete).forEach(key => {
          if (key === data) {
            currentFiledMapping.dateStyle = "1"
            if (tempComplete[key].component_shape?.includes("cxDate")) {
              currentFiledMapping.isDate = true
            } else {
              currentFiledMapping.isDate = false
            }
          }
        })
      }
      this.$changeOptionsEV(
        currentFiledMapping,
        "filedMapping",
        false,
        null,
        { ...this.ids, elementInDataGridId: params.elementInDataGridId },
        true
      )
      if (currentFiledMapping.value === "viewNum") {
        this.$changeOptionsEV(
          true,
          "isHasViewNum",
          false,
          null,
          { ...this.ids, elementInDataGridId: params.elementInDataGridId },
          true
        )
      }
      // 手动触发一次数据响应
      if (params.flag !== "checked") {
        this.startDraw()
      }
    },
    changeItemOptions(data, params, type) {
      this.$changeOptionsEV(data, type, false, null, { ...this.ids, elementInDataGridId: params.elementInDataGridId }, false)
    },
    // 触发一次数据响应
    startDraw() {
      const rectAttr = this.getAttrById(this.$store.state[this.request_prefix], { ...this.ids }, "dataGrid")
      this.$eventBus.$emit("subPage-component-init", {
        type: rectAttr.innerElement + "_" + rectAttr.innerElement
      })
    },
    // 改变跳转组件
    changeLinksHandle(flag, index) {
      const _options = this.$getOptions({
        ...this.ids
      })?.options
      let detailPageElementIndexList = JSON.parse(JSON.stringify(_options.detailsPageTarget))
      // 兼容老数据返回值为{}会报错
      if (!Array.isArray(detailPageElementIndexList)) {
        detailPageElementIndexList = []
      }
      if (flag) {
        detailPageElementIndexList.push(index)
      } else {
        detailPageElementIndexList = detailPageElementIndexList.filter(val => val !== index)
      }
      // 当删除元素后 清除掉多余的选中态
      let allLayoutId = []
      this.getAllElements.forEach(item => {
        allLayoutId.push(item.elementInDataGridId)
      })
      detailPageElementIndexList = detailPageElementIndexList.filter(val => allLayoutId.includes(val))
      // 全选按钮状态控制
      if (detailPageElementIndexList.length === 0) {
        this.allElementsIsCheckedAll = false
        this.getAllElementsIsCheckedAll = false
      } else {
        if (detailPageElementIndexList.length !== this.getAllElements.length) {
          this.allElementsIsCheckedAll = true
        } else {
          this.allElementsIsCheckedAll = false
        }
      }
      this.$changeOptionsEV(detailPageElementIndexList, "detailsPageTarget", false)
    },
    // 选中所有元素
    checkAllElementsHandle($event) {
      this.allElementsIsCheckedAll = false // 去掉部分选中状态
      for (let i = 0; i < this.getAllElements.length; i++) {
        this.changeFiledMappingHandle($event, {
          elementInDataGridId: this.getAllElements[i].elementInDataGridId,
          flag: "checked"
        })
      }
    },
    // 高亮显示当前组件
    highlightedBaseComponent(element) {
      let container = document.querySelector(
        `.container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}-cell_id_${this.ids.cellId} .dataGrid-cell-layout`
      )
      let _class = `container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}-cell_id_${this.ids.cellId}-elementInDataGridId_${element.elementInDataGridId}`
      const dom = document.getElementsByClassName(_class)
      const box = document.createElement("div") //创建元素
      let styleObject = {
        transform: dom[0].style.transform,
        "margin-left": dom[0].style.marginLeft,
        top: dom[0].style.top,
        position: "absolute",
        background: "rgba(118, 163, 211, 0.7);",
        width: dom[0].style.width,
        height: dom[0].style.height
      }
      let styleArr = []
      Object.keys(styleObject).forEach(key => {
        styleArr.push([key, styleObject[key]].join(":"))
      })
      box.setAttribute("id", `${_class}-mask`)
      box.setAttribute("style", styleArr.join(";"))
      container.appendChild(box)
    },
    // 取消高亮显示当前组件
    cancelHighlightedBaseComponent(element) {
      let _class = `container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}-cell_id_${this.ids.cellId}-elementInDataGridId_${element.elementInDataGridId}`
      document.getElementById(`${_class}-mask`).remove()
    }
  },
  mounted() {
    this.getBaseModuleDataLoop()
  },
  beforeDestroy() {}
}
</script>

<style lang="scss" scoped>
.col_li {
  padding-left: 8px;
}
.col_li:hover {
  background: var(--themeColorSelectBg);
}
.syncCol_content {
  background: var(--inputArrowBgColor);
  border: 1px solid var(--borderColorTen);
  border-radius: 4px;
  padding: 8px 4px;
}

::v-deep .el-button--primary {
  background-color: var(--themeColor);
}
::v-deep .el-radio {
  margin-top: 16px;
}
::v-deep .el-el-radio__label {
  font-size: 14px;
  line-height: 20px;
}
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 8px;
}
::v-deep .verticallyCenter .el-checkbox {
  margin-right: 0;
}
::v-deep .mapping_date_content .el-input .el-input__inner {
  background: var(--inputArrowBgColor);
}
.custom-param-checkbox .el-checkbox {
  display: block;
}
.mapping_content {
  padding: 8px;
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  border: 1px solid rgba(233, 233, 233, 1);
  background-color: rgba(247, 248, 250, 1);
  &.checked,
  &:hover {
    border: 1px solid rgba(36, 0, 255, 0.16);
    background-color: rgba(36, 0, 255, 0.04);
  }
  .content-title {
    height: 18px;
    line-height: 18px;
    font-size: 13px;
  }
  .select_content {
    ::v-deep .el-input__inner {
      font-size: 13px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 0px 1px rgba(233, 233, 233, 1) inset;
    }
  }
  &.checked {
    .select_content {
      ::v-deep .el-input__inner {
        font-size: 13px;
        background-color: rgba(36, 0, 255, 0.1);
        color: rgba(36, 0, 255, 1);
        box-shadow: 0px 0px 0px 1px rgba(36, 0, 255, 0.16) inset;
        &:hover {
          background-color: rgba(36, 0, 255, 0.2);
        }
      }
      ::v-deep .el-select__caret {
        color: rgba(36, 0, 255, 1);
      }
      ::v-deep .is-focus .el-input__inner {
        background-color: rgba(36, 0, 255, 0.2);
      }
    }
  }
  .mapping_date_content {
    height: 20px;
    .date-label {
      font-size: 13px;
      color: var(--thirdTextColor);
      margin-right: 4px;
    }
    ::v-deep .el-dropdown {
      font-size: 13px;
    }
  }
  .el-checkbox {
    margin-right: 4px;
  }
  .vedio-style {
    font-size: 13px;
  }
}
.custom-dropdown {
  .dropdown-title-show {
    padding: 7px 12px;
    border-bottom: 1px solid rgba(233, 233, 233, 1);
    ::v-deep .el-checkbox__label {
      font-size: 13px;
    }
  }
  ::v-deep .el-dropdown-menu__item {
    height: 34px;
    line-height: 34px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.8);
    .active {
      color: rgba(43, 103, 255, 1);
    }
  }
}
.bigScreen {
  .mapping_content {
    color: rgba(255, 255, 255, 0.8);
    border-color: rgba(255, 255, 255, 0.08);
    background-color: rgba(40, 42, 46, 1);
    &.checked,
    &:hover {
      border-color: rgba(166, 139, 255, 0.16);
      background-color: rgba(166, 139, 255, 0.04);
    }
    .select_content {
      ::v-deep .el-input__inner {
        background-color: rgba(31, 33, 36, 1);
        box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.08) inset;
      }
    }
    &.checked {
      .select_content {
        ::v-deep .el-input__inner {
          background-color: rgba(166, 139, 255, 0.1);
          color: rgba(166, 139, 255, 1);
          box-shadow: 0px 0px 0px 1px rgba(166, 139, 255, 0.16) inset;
          &:hover {
            background-color: rgba(166, 139, 255, 0.2);
          }
        }
        ::v-deep .el-select__caret {
          color: rgba(166, 139, 255, 1);
        }
        ::v-deep .is-focus .el-input__inner {
          background-color: rgba(166, 139, 255, 0.2);
        }
      }
    }
  }
}
.custom-dropdown.bigScreen {
  .dropdown-title-show {
    border-color: rgba(55, 55, 55, 1);
  }
  ::v-deep .el-dropdown-menu__item {
    color: rgba(255, 255, 255, 0.8);
    .active {
      color: rgba(43, 103, 255, 1);
    }
  }
}
.verticallyBetweenCenter {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
